// extracted by mini-css-extract-plugin
module.exports = {"ctaWrap":"PremiumTableCTA_ctaWrap___IfEl","ctaContent":"PremiumTableCTA_ctaContent__hN9eP"};